import React, { useEffect, useState } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { filter, find, flow, map } from 'lodash/fp';
import axios from 'views/I9/modules/axios';

const loadUsersDpI9 = async () => {
  const res = await axios.get(
    `opti9_delegues_prog?_associations=*individu&individu.delete=0&_sort=individu.nom,individu.prenom&individu._fields=nom,prenom,idindividu`,
  );

  return map(
    row => ({
      ...row.individu,
      autocompleteGroupName: 'DP I9',
    }),
    res.data,
  );
};
const loadUsersI9 = async () => {
  const res = await axios.get(
    `individu?_associations=*partenaire&delete=0&partenaire.idcommercialisateur=1&partenaire.delete=0&_sort=nom,prenom&_limit=1000&_fields=nom,prenom,idindividu&partenaire._fields=idpartenaire`,
  );

  return flow(
    filter(
      individu =>
        !individu.nom.match(
          // Rule taken from the legacy code /prog-1.php:1738
          /^(digit|stagiaire|immobilier|vente|transfert|centrale|demonstration|promoteur|factur|lineup|tremplin|admin|service)/i,
        ),
    ),
    map(row => ({
      ...row,
      autocompleteGroupName: 'I9',
    })),
  )(res.data);
};
const loadUsersCapi = async () => {
  const res = await axios.get(
    `individu?delete=0&idpartenaire=820261&_sort=nom,prenom&_limit=10000&_fields=nom,prenom,idindividu`,
  );

  return flow(
    map(row => ({
      ...row,
      autocompleteGroupName: 'CapiFrance',
    })),
  )(res.data);
};
const loadUsersOH = async () => {
  const res = await axios.get(
    `individu?delete=0&idpartenaire=820262&_sort=nom,prenom&_limit=10000&_fields=nom,prenom,idindividu`,
  );

  return flow(
    map(row => ({
      ...row,
      autocompleteGroupName: 'OptimHome',
    })),
  )(res.data);
};

const ApporteParAutoComplete = ({ onChange, initialValue }) => {
  const [value, setValue] = React.useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [options, setOptions] = useState({
    dpI9: [],
    i9: [],
    capi: [],
    oh: [],
  });

  useEffect(() => {
    const loadAllUsers = async () => {
      setOptions({
        dpI9: await loadUsersDpI9(),
        i9: await loadUsersI9(),
        capi: await loadUsersCapi(),
        oh: await loadUsersOH(),
      });

      setIsLoaded(true);
    };

    loadAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLoaded) {
      setValue(find({ idindividu: initialValue }, [...options.dpI9, ...options.i9, ...options.capi, ...options.oh]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, options, setValue]);

  const optionLabel = option => `${option.nom} ${option.prenom}`;

  return (
    <Autocomplete
      freeSolo
      options={[...options.dpI9, ...options.i9, ...options.capi, ...options.oh]}
      groupBy={option => option.autocompleteGroupName}
      getOptionLabel={optionLabel}
      onChange={onChange}
      value={value}
      renderInput={params => <TextField {...params} label='Apporté par' variant='outlined' size='small' fullWidth />}
    />
  );
};

export default ApporteParAutoComplete;
